(function () {
  var root = document.getElementById('GaExtras');
  if (!root) return;

  // Place this section directly under the main product section.
  var wrap = root.closest('.shopify-section');
  var info = document.querySelector('product-info');
  var mainSec = info && info.closest('.shopify-section');
  if (wrap && mainSec && mainSec !== wrap) mainSec.after(wrap);

  function money(c) {
    try { if (window.theme && theme.Currency) return theme.Currency.formatMoney(c, theme.settings.moneyFormat); } catch (e) {}
    return '$' + (c / 100).toFixed(2);
  }

  async function addItems(items, btn, msgEl) {
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    try {
      var cfg = (window.theme && theme.utils && theme.utils.fetchConfig) ? theme.utils.fetchConfig('javascript') : { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } };
      cfg.body = JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname });
      var res = await fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add', cfg);
      var json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart.');
      if (window.theme && theme.settings && theme.settings.cartType === 'page') { window.location.href = theme.routes.cart_url; return; }
      var cart = await (await fetch(((window.theme && theme.routes && theme.routes.cart_url) || '/cart') + '.js')).json();
      cart.sections = json.sections;
      if (window.theme && theme.pubsub) theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'ga-extras', cart: cart });
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: json } }));
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.show) drawer.show(btn); else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      if (msgEl) { msgEl.hidden = true; }
    } catch (err) {
      if (msgEl) { msgEl.textContent = err.message; msgEl.hidden = false; }
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  }


  // Show arrows only when a row can actually scroll, and dim them at the ends.
  function syncArrows() {
    root.querySelectorAll('[data-gax-track]').forEach(function (tr) {
      var box = tr.closest('.gax-softbox, .gax-acc__body');
      var row = box && box.querySelector('.gax-arrows');
      if (!row) return;
      var over = tr.scrollWidth > tr.clientWidth + 4;
      row.parentElement.style.display = over ? '' : 'none';
      var btns = row.querySelectorAll('[data-gax-scroll]');
      if (btns.length === 2) {
        btns[0].disabled = tr.scrollLeft <= 2;
        btns[1].disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 2;
      }
    });
  }
  root.querySelectorAll('[data-gax-track]').forEach(function (tr) {
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(syncArrows); }, { passive: true });
  });
  root.querySelectorAll('details').forEach(function (dt) { dt.addEventListener('toggle', syncArrows); });
  window.addEventListener('resize', syncArrows);
  window.addEventListener('load', syncArrows);
  syncArrows();

  // Tabs
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gax-tab]');
    if (t) {
      var box = root.querySelector('[data-gax-tabs]');
      if (!box) return;
      var i = t.getAttribute('data-gax-tab');
      box.querySelectorAll('.gax-tab').forEach(function (b) { var on = b.getAttribute('data-gax-tab') === i; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on); });
      box.querySelectorAll('[data-gax-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-gax-panel') !== i; });
      if (!t.classList.contains('gax-tab')) box.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var s = e.target.closest('[data-gax-scroll]');
    if (s) {
      var track = s.closest('.gax-softbox, .gax-acc__body').querySelector('[data-gax-track]');
      if (track) {
        var card = track.firstElementChild;
        var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        track.scrollBy({ left: (+s.getAttribute('data-gax-scroll')) * step, behavior: 'smooth' });
      }
      return;
    }
    var add = e.target.closest('[data-setup-add]');
    if (add) {
      var card = add.closest('.gax-card');
      var sel = card.querySelector('[data-setup-select]');
      var id = sel ? sel.value : add.value;
      addItems([{ id: +id, quantity: 1 }], add, add.closest('.gax-softbox').querySelector('[data-gax-msg]'));
      return;
    }
    var fb = e.target.closest('[data-fbt-add]');
    if (fb) {
      var fbt = root.querySelector('[data-gax-fbt]');
      var items = [];
      fbt.querySelectorAll('[data-fbt]:checked').forEach(function (c) {
        var id = c.value;
        if (c.hasAttribute('data-main')) {
          var f = document.querySelector('product-info form[is="product-form"]');
          var el = f && f.elements.namedItem('id');
          if (el && el.value) id = el.value;
        }
        items.push({ id: +id, quantity: 1 });
      });
      if (!items.length) return;
      addItems(items, fb, fbt.querySelector('[data-gax-msg]'));
    }
  });

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-setup-select]')) {
      var o = e.target.selectedOptions[0];
      e.target.closest('.gax-card').querySelector('[data-setup-price]').textContent = money(+o.dataset.price);
    }
    if (e.target.matches('[data-fbt]')) fbtTotal();
  });

  function fbtTotal() {
    var fbt = root.querySelector('[data-gax-fbt]');
    if (!fbt) return;
    var t = 0, c = 0;
    fbt.querySelectorAll('[data-fbt]').forEach(function (x) {
      var th = fbt.querySelector('[data-fbt-thumb="' + x.value + '"]');
      if (th) th.classList.toggle('is-off', !x.checked);
      if (x.checked) { t += +x.dataset.price; c += +x.dataset.compare; }
    });
    fbt.querySelector('[data-fbt-total]').textContent = money(t);
    var cs = fbt.querySelector('[data-fbt-compare]');
    cs.textContent = money(c); cs.hidden = !(c > t);
    fbt.querySelector('[data-fbt-add]').disabled = t === 0;
  }

  // Keep "This item" in sync with the variant picker.
  document.addEventListener('DOMContentLoaded', function () {
    try {
      if (window.theme && theme.pubsub) theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        var main = root.querySelector('[data-fbt][data-main]');
        if (!v || !main) return;
        main.value = v.id; main.dataset.price = v.price;
        main.checked = !!v.available; main.disabled = !v.available;
        main.dataset.compare = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
        root.querySelector('[data-fbt-main-price]').innerHTML = (v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '<strong>' + money(v.price) + '</strong>';
        var vt = root.querySelector('[data-fbt-main-variant]');
        if (vt) vt.textContent = v.title && v.title !== 'Default Title' ? ' · ' + v.title : '';
        fbtTotal();
      });
    } catch (e) {}
  });
})();
